import { forwardRef, type Ref, type SVGProps } from "react";
const IconWhiteBalanceOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M29 6H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1m-1 18H4V8h24Z" />
    <path d="m11.52 19 .93-3.53c0-.15.09-.42.17-.78s.12-.64.14-.8c0 .13.06.4.14.79s.15.66.18.78L14 19h1.66l1.75-6.73H16l-.88 3.67c-.06.22-.12.51-.19.87s-.12.66-.15.9q0-.37-.15-.9c-.06-.34-.12-.6-.16-.77l-1-3.77h-1.39l-1 3.77a7 7 0 0 0-.19.85c-.07.37-.11.64-.13.82-.07-.5-.18-1.09-.34-1.77l-.88-3.67H8.11L9.86 19Z" />
    <path d="M22.7 18.47a1.67 1.67 0 0 0 .68-1.47 1.65 1.65 0 0 0-.29-1 1.52 1.52 0 0 0-.94-.54 1.18 1.18 0 0 0 .77-.47 1.64 1.64 0 0 0 .29-1 1.4 1.4 0 0 0-.66-1.29 4.1 4.1 0 0 0-2.13-.41h-2.13V19h2.57a2.94 2.94 0 0 0 1.84-.53m-3-5h.77a1.77 1.77 0 0 1 .91.17.57.57 0 0 1 .29.55.67.67 0 0 1-.26.59 1.6 1.6 0 0 1-.86.18h-.85Zm0 4.38v-1.79h.91c.81 0 1.22.28 1.22.83a.83.83 0 0 1-.29.69 1.44 1.44 0 0 1-.89.23Z" />
  </svg>
);
const ForwardRef = forwardRef(IconWhiteBalanceOutlineSVG);
ForwardRef.displayName = "IconWhiteBalanceOutline";
export { ForwardRef as IconWhiteBalanceOutline };
